import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackVertical20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconStackVertical20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 3.5h13v1.444h-13zM2 3.5A1.5 1.5 0 0 1 3.5 2h13A1.5 1.5 0 0 1 18 3.5v1.444a1.5 1.5 0 0 1-1.5 1.5h-13a1.5 1.5 0 0 1-1.5-1.5zm14.5 5.778h-13v1.444h13zm-13-1.5a1.5 1.5 0 0 0-1.5 1.5v1.444a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V9.278a1.5 1.5 0 0 0-1.5-1.5zm13 7.278h-13V16.5h13zm-13-1.5a1.5 1.5 0 0 0-1.5 1.5V16.5A1.5 1.5 0 0 0 3.5 18h13a1.5 1.5 0 0 0 1.5-1.5v-1.444a1.5 1.5 0 0 0-1.5-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackVertical20);
